module.exports = __webpack_public_path__ + "img/businesLicese3.de5a486e.png";